import React, { useContext } from "react";
import commonContext from "../../../context/common";

function FactStatement() {
    const { lead, utils } = useContext(commonContext);
    return (
        <>
            <div className="details-blue-wrap w-full py-3 md:py-5 xl:py-8 my-5">
                <p className="openSans-Reg text-black mb-3 md:mb-5 text-2xl md:text-2xl lg:text-3xl xl:text-4xl w-full">
                    Schedule-cum-key Fact statement
                </p>
                <ul className="flex flex-wrap justify-between lg:flex-row">
                    <li className="mb-3 lg:mb-0 w-1/2 lg:w-3/12">
                        <p className="openSans-Reg light-gray-1 text-xs md:text-base lg:text-base xl:text-base">
                            Agreement Date
                        </p>
                        <p className="openSans-Reg text-black text-base sm:text-xl md:text-2xl">
                            {utils.getDateInFormat()}
                        </p>
                    </li>
                    <li className="mb-3 lg:mb-0 w-1/2 lg:w-3/12">
                        <p className="openSans-Reg light-gray-1 text-xs md:text-base lg:text-base xl:text-base">
                            Agreement No.
                        </p>
                        <p className="openSans-Reg text-black text-base sm:text-xl md:text-2xl">
                            {lead.uniqueReferenceNo}
                        </p>
                    </li>
                    <li className="mb-3 lg:mb-0 w-1/2 lg:w-3/12">
                        <p className="openSans-Reg light-gray-1 text-xs md:text-base lg:text-base xl:text-base">
                            Borrowing Purpose
                        </p>
                        <p className="openSans-Reg text-black text-base sm:text-xl md:text-2xl">
                            Personal
                        </p>
                    </li>
                    <li className="mb-3 lg:mb-0 w-1/2 lg:w-3/12">
                        <p className="openSans-Reg light-gray-1 text-xs md:text-base lg:text-base xl:text-base">
                            Place of Agreement
                        </p>
                        <p className="openSans-Reg text-black text-base sm:text-xl md:text-2xl">
                            {lead.city}
                        </p>
                    </li>
                </ul>
            </div>
        </>
    );
}

export default FactStatement;
